/***
 * Created on 2023/8/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import LoginDeviceTable from "./login_device_table";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../../service/api";
import {addDays} from "../../../service/datetime";
import CheckWarningDialog from "./check_warning_dialog";
import {useUA} from "use-ua-parser-js";
import {UAParser} from 'ua-parser-js';


function LoginDevice(props) {
    const { t } = useTranslation();
    const [showInactiveWarning, setShowInactiveWarning] = useState(false);

    const showDomain = (data) => {
        if (data?.domain?.toLowerCase().indexOf('cn') > 0) {
            return t('@China@');
        }
        return t('@Global@');
    }

    const remote_login_user = useQuery({
        queryKey: ['get_remote_login_user'],
        queryFn: async () => {
            const data = await apiGet(`/ajax/remote_login_user`);
            const today = new Date();
            let show_warning = false;
            for (const rec of data) {
                const agent = new UAParser(rec?.user_agent).getResult();
                rec.display_device_name = rec?.device?.device_model || (agent?.os?.name || agent?.browser?.name ? `${agent?.os?.name} ${agent?.os?.browser?.name || ""} ${agent?.os?.browser?.version || ""}` : agent?.ua);
                rec.name = rec?.device?.device_hostname ? rec.device.device_hostname : rec.client_name  || '----';
                rec.display_domain = showDomain(rec);
                const last_login_day = addDays(rec.last_login, 32);
                if (last_login_day < today) {
                    show_warning = true;
                }
            }
            if (show_warning) {
                setShowInactiveWarning(true);
            }
            return data;
        }
    });

    return (
        <section className="page-body">
            <div className="page-content page-content--security__logged-in-devices">
                <section className="logged-in-devices--prompt">
                    <p className="text-14">{t('@View and manage devices that has been logged into your QID account for the last 30 days.@')}&nbsp;
                        <a href={`${window.acc_mf.account.CMS_URL}/faq/_faq_q_how-can-i-see-which-devices-logged-in-to-my-qid-account?`} target="_blank">
                            {t('@Learn more@')}
                        </a>
                    </p>
                </section>
                <div className="logged-in-devices--table">
                    <LoginDeviceTable data={remote_login_user.data}/>
                </div>
            </div>
            {showInactiveWarning && <CheckWarningDialog showModal={showInactiveWarning} closeModal={()=>setShowInactiveWarning(false)}/>}
        </section>
    );
}

export default LoginDevice;